import { Box, Typography } from '@mui/material';

export type DischargeNoteReviewSectionProps = {
  title: string;
  children: React.ReactNode;
};

export const DischargeNoteReviewSection: React.VFC<DischargeNoteReviewSectionProps> = ({ title, children }) => {

  return (
    <Box display="flex" flexDirection="column" gap="16px" className="Uplift-DischargeNoteSection">
      <Typography variant="h5">{title}</Typography>
      {children}
    </Box>
  );
};

export type DischargeNoteReviewSubSectionProps = {
  title: string;
  children: React.ReactNode;
  isEmpty?: boolean;
  emptyMessage?: string;
};

export const DischargeNoteReviewSubSection: React.VFC<DischargeNoteReviewSubSectionProps> = ({ title, children, isEmpty = false, emptyMessage = 'Not Filled' }) => {

  let content: React.ReactNode = null;

  if (!children || isEmpty) {
    content = <Typography>{emptyMessage}</Typography>;
  } else {
    content = children;
  }

  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Typography variant="overline" color="secondary">{title}</Typography>
      {content}
    </Box>
  );
};
